import React from 'react';
import { css } from 'aphrodite/no-important';

import style from './styles';

const ProjectIntro = ({ title, description, tags }) => (
  <div className={ css(style.container) } id={ title }>
    <div className={ css(style.allText) }>
      <h1 className={ css(style.header) }>{title}</h1>
      <h3 className={ css(style.content) }>{description} </h3>
      <h4 className={ css(style.tagCategories) }>{tags}</h4>
    </div>
  </div>
);

ProjectIntro.propTypes = {
  title: React.PropTypes.string.isRequired,
  link: React.PropTypes.string.isRequired,
  description: React.PropTypes.string.isRequired,
  tags: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
};

export default ProjectIntro;



// WEBPACK FOOTER //
// ./src/components/ProjectIntro/index.js